import { type RootState } from '../../../lib/store';

export const selectProjectId = (state: RootState) => state.annotatorQueue?.projectId;
export const selectBatchId = (state: RootState) => state.annotatorQueue?.batchId;
export const selectProjectsListPage = (state: RootState) =>
  state.annotatorQueue?.projectsListPage ?? 0;
export const selectProjectsListPageSize = (state: RootState) =>
  state.annotatorQueue?.projectsListPageSize ?? 25;
